import {combineReducers} from 'redux';
import entretiens from './entretiens'
import infos from './infos'
export default combineReducers({
    entretiens,
    infos
})


// WEBPACK FOOTER //
// ./src/reducers/salarie/index.js